const solidworksApiCourse = {
    id: "solidworks-api",
    name: "Solidworks API",
syllabusPdf: "/syllabus/Solidworks-Syllabus.pdf",


    hero: {
        title: "Solidworks API",
         subtitle: "Live & Interactive Online Training",

        logo: "/solidworks-api-logo.webp",

        points: [
            "Master SolidWorks customization through API programming with C# .NET. Automate 3D modeling, assembly design, and drawing creation.",

            "Ideal for engineers and CAD professionals seeking high salary jobs and super fast career growth with advanced SolidWorks automation & customization skills.",

            "Learn everything you need to shift your career from traditional design roles to high-demand SolidWorks customization and automation using C# and the SolidWorks API.",

            "We start from the basics of computer programming, so even beginners with no prior coding experience can excel.",

            "Our students are already placed in top companies across India — including TCS, Cognizant, Tata Technologies, L&T Technology Services, ITC Infotech, Tech Mahindra, Ford, Kennametal, Honeywell, and more."
        ]
    },

    highlights: [
        {
            title: "High Salary",
            description:
                "SolidWorks Automation & Customization Engineers get 4 to 5 times more salary than Design Engineers. Because they can automate almost all the works and be 100 times more productive and 100% error free and use only less software licenses."
        },
        {
            title: "Good Demand",
            description:
                "Design is a well-known skill among Mechanical Engineers; there is intense competition for design jobs. On the other hand, SOLIDWORKS Automation & Customization is a niche expertise, with only a few engineers."
        },
        {
            title: "Easier To Learn",
            description:
                "While SOLIDWORKS Design is generally easier to learn, SOLIDWORKS Automation & Customization can be more challenging. With our extensive experience in this field, we aim to simplify the process for you with our step by step training."
        }
    ],

    whyLearn: [
        {
            title: "Automate Repetitive Tasks",
            description:
                "Save time by automating common tasks like drawing generation, dimensioning, exporting files, or renaming parts — no more manual clicks!"
        },
        {
            title: "Batch Process Files",
            description:
                "With the API, you can open, modify, and save hundreds of SolidWorks files in bulk — perfect for large assemblies or standardized drawings"
        },
        {
            title: "Customize Workflows",
            description:
                "Tailor SolidWorks to fit your company’s or client’s workflow by developing custom features, interfaces, and commands inside the SolidWorks environment."
        },
        {
            title: "Create Configurable Designs",
            description:
                "Easily build configurable and rule-driven parts/assemblies, enabling on-the-fly model generation based on parameters or user input (ideal for product configurators)"
        },
        {
            title: "Boost Career Opportunities",
            description:
                "Engineers with SolidWorks API skills are in high demand in CAD automation, mechanical design, and design automation roles — it adds strong value to your resume."
        },
        {
            title: "Build Custom Add-ins & Tools",
            description:
                "You can develop full-fledged add-ins, plugins, and macro tools that integrate directly into the SolidWorks UI, improving productivity for you or your team."
        },
        {
            title: "Reduce Human Error",
            description:
                "Automation reduces errors that occur in repetitive manual modeling, ensuring greater consistency and accuracy in output."
        },
        {
            title: "Integrate with External Systems",
            description:
                "Use the API to link SolidWorks with ERP, PLM, Excel, databases, or cloud platforms, creating seamless design-data integration workflows."
        },
        {
            title: "Support Product Configurators",
            description:
                "The API allows creation of backend engines for online/offline configurators, so customers or sales teams can generate custom product models instantly."
        },
        {
            title: "Enhance Learning of Software Engineering",
            description:
                "Using the SolidWorks API teaches you real-world object-oriented programming in C# or VB.NET while applying it to a mechanical design context."
        }
    ],

    syllabus: [
        {
            name: "C#.NET",
            modules: [
                {
                    number: 1,
                    title: "Getting Started",
                    topics: [
                        "Environment Setup",
                        "Basic Syntax",
                        "Program Structure"
                    ]
                },
                {
                    number: 2,
                    title: "Variables & Data Types",
                    topics: [
                        "Data Types",
                        "Variables",
                        "Constants",
                        "Modifiers (public, private, static, etc.)"
                    ]
                },
                {
                    number: 3,
                    title: "Statements & Operations",
                    topics: [
                        "Statements",
                        "Operators",
                        "Using Math Functions"
                    ]
                },
                {
                    number: 4,
                    title: "Control Flow",
                    topics: [
                        "Decision Making (if, else, switch)",
                        "Loops (for, while, do-while, foreach)"
                    ]
                },
                {
                    number: 5,
                    title: "Strings & DateTime",
                    topics: [
                        "Strings (Concatenation, Methods, Formatting)",
                        "Date & Time (DateTime, formatting, parsing)"
                    ]
                },
                {
                    number: 6,
                    title: "Arrays & Collections",
                    topics: [
                        "Arrays: 1D, 2D & 3D",
                        "Collections:",
                        "List",
                        "ArrayList",
                        "Dictionary",
                        "Hashtable"
                    ]
                },
                {
                    number: 7,
                    title: "Functions & Parameters",
                    topics: [
                        "Functions",
                        "Arguments",
                        "Return Types",
                        "Parameters",
                        "out Parameters",
                        "ref Parameters"
                    ]
                },
                {
                    number: 8,
                    title: "Structs & Enums",
                    topics: [
                        "Struct",
                        "Enum"
                    ]
                },
                {
                    number: 9,
                    title: "Object-Oriented Programming",
                    topics: [
                        "Classes & Objects",
                        "Constructor",
                        "Destructor",
                        "Access Levels",
                        "Static Class",
                        "Static Methods",
                        "Stack Memory vs Heap Memory"
                    ]
                },
                {
                    number: 10,
                    title: "Advanced OOP Concepts",
                    topics: [
                        "Abstract Class",
                        "Abstract Methods",
                        "Interfaces",
                        "Inheritance",
                        "Single",
                        "Multiple (via interfaces)",
                        "Multilevel",
                        "Polymorphism",
                        "Method Overloading",
                        "Method Overriding"
                    ]
                },
                {
                    number: 11,
                    title: "Exception Handling",
                    topics: [
                        "Try-Catch-Finally",
                        "Custom Exceptions"
                    ]
                },
                {
                    number: 12,
                    title: "File & Directory Handling",
                    topics: [
                        "File Handling (Create, Read, Write, Append)",
                        "Directory Handling (Create, Delete, Move)"
                    ]
                },
                {
                    number: 13,
                    title: "Application Development",
                    topics: [
                        "Console Apps",
                        "Creating Console Applications",
                        "Windows Forms",
                        "Form Application Setup",
                        "Form Controls (TextBox, Button, ListBox, etc.)",
                        "Dialog Boxes (MessageBox, Open/Save Dialogs)",
                        "Advanced Forms (MDI, Tab Controls)",
                        "Event Handling (Click, Load, etc.)"
                    ]
                },
                {
                    number: 14,
                    title: "Reusability & Integration",
                    topics: [
                        "Class Library & DLL Creation",
                        "Interacting with Notepad Files",
                        "Interacting with Excel Files"
                    ]
                },
                {
                    number: 15,
                    title: "Visual Studio Essentials",
                    topics: [
                        "Build, Debug, IntelliSense",
                        "Solution Explorer",
                        "Project & File Management"
                    ]
                },
                {
                    number: 16,
                    title: "Object Model Fundamentals",
                    topics: [
                        "Object Model Overview",
                        "SOLIDWORKS API Object Model",
                        "Application Objects",
                        "SolidWorks Object",
                        "SOLIDWORKS Type Library",
                        "Connecting to New Documents"
                    ]
                },
                {
                    number: 17,
                    title: "Core Document Objects",
                    topics: [
                        "ModelDoc2 Object",
                        "ModelDocExtension Object",
                        "PartDoc Object",
                        "AssemblyDoc Object",
                        "DrawingDoc Object"
                    ]
                },
                {
                    number: 18,
                    title: "Automating Part Design",
                    topics: [
                        "Automation Tools for Parts",
                        "Setting Material",
                        "Creating Sketch Rectangle",
                        "Adding Dimensions",
                        "Selection on Creation",
                        "Creating Sketch Circle",
                        "Creating Extruded Features",
                        "Enabling Contour Selection for Extrusion",
                        "Creating Revolved Features",
                        "Command Automation",
                        "Standard Commands",
                        "View Commands",
                        "Sketch Commands",
                        "Sketch Tools Commands",
                        "Features Commands",
                        "Sketch Relations Commands",
                        "Reference Geometry Commands"
                    ]
                },
                {
                    number: 19,
                    title: "Assembly Automation",
                    topics: [
                        "Case Study: Automation Tool for Assemblies",
                        "Understanding Transforms",
                        "Creating Math Transforms",
                        "The Transformation Matrix",
                        "Activating Documents",
                        "Working with Invisible Documents",
                        "Object Collections",
                        "Geometry & Component Handling",
                        "Curve and Edge Collections",
                        "Face Collection",
                        "Adjacent Faces",
                        "Points Collection",
                        "Curve Parameters",
                        "Adding and Mating Components",
                        "Adding Mates"
                    ]
                },
                {
                    number: 20,
                    title: "Drawing Automation",
                    topics: [
                        "Case Study: Automating Drawing Creation",
                        "Getting Configuration Names",
                        "Creating Sheets and Views",
                        "Traversing Drawing Views",
                        "Inserting Annotations",
                        "Saving in Multiple Formats",
                        "Drawing Command Sets",
                        "Drawing Commands",
                        "Annotation Commands",
                        "Layer Commands"
                    ]
                },
                {
                    number: 21,
                    title: "Selection & Filters",
                    topics: [
                        "Programming with a Selected Object",
                        "Selection Manager",
                        "Accessing Selection Manager",
                        "Counting Selected Objects",
                        "Accessing Selected Objects",
                        "Object Type & Feature Type Recognition",
                        "Feature Data Management",
                        "Feature Data Objects",
                        "Accessing Feature Data",
                        "Modifying Feature Data Properties",
                        "Modify Object Definition",
                        "Topology & Geometry Traversal",
                        "SOLIDWORKS BREP Model",
                        "Traversing Topology & Geometry",
                        "Case Study: Body and Face Traversal",
                        "Listing Body Pointers",
                        "Face Material Properties",
                        "Feature Manager Design Tree",
                        "Traversing Feature Tree from Top",
                        "Displaying Feature Names & Types",
                        "Setting Feature Suppression",
                        "Setting Feature UI State",
                        "Obtaining Features by Tree Position"
                    ]
                },
                {
                    number: 22,
                    title: "Properties & Attributes",
                    topics: [
                        "Case Study: Custom Properties",
                        "Adding Custom Properties",
                        "Custom Property Manager Object",
                        "Set/Get Property Values",
                        "Getting Property Names & Count",
                        "Configuration Properties",
                        "Case Study: Configurations With Custom Properties",
                        "Mass Properties",
                        "Returning Mass Properties from Model",
                        "MassProperty2 Object",
                        "Add Mass Properties as Custom Properties",
                        "File & Attribute Handling",
                        "Case Study: File Summary Information",
                        "Adding Summary Information",
                        "Case Study: Document Attributes",
                        "Naming and Managing Attributes",
                        "AttributeDef and Parameter Objects",
                        "Face & Edge Attributes",
                        "Finding Cylindrical Faces & Attaching Attributes",
                        "Displaying Callouts",
                        "Callout Object",
                        "Attribute Traversal Types"
                    ]
                }
            ]
        },

        {
            name: "SolidWorks API",
            modules: [
                {
                    number: 1,
                    title: "Introduction",
                    topics: [
                        "Need for CAD Automation",
                        "Tools for Automation",
                        "Understanding Runtime Applications"
                    ]
                },
                {
                    number: 2,
                    title: "Getting Started with SolidWorks API",
                    topics: [
                        "Connecting to SolidWorks",
                        "SolidWorks API Object Model",
                        "SolidWorks Interface Elements",
                        "Working with:",
                        "ModelDoc2 Object",
                        "PartDoc Object",
                        "AssemblyDoc Object",
                        "DrawingDoc Object",
                        "Determining the Active Document Type",
                        "Working with SolidWorks Documents",
                        "Creating New SolidWorks Files",
                        "Opening, Closing, Saving & “Save As” Operations",
                        "Exporting Documents to Other Formats"
                    ]
                },
                {
                    number: 3,
                    title: "SolidWorks Part Automation",
                    topics: [
                        "Sketch Functions: Circle, Rectangle, Arc Slot, etc.",
                        "Feature Functions: Extrude, Pattern, Hole, etc.",
                        "Traversing Features in a Model",
                        "Detecting Feature Types: Hole, Extrusion, Draft, Fillet, etc.",
                        "Identifying Feature Subtypes (e.g., Hole Variants)"
                    ]
                },
                {
                    number: 4,
                    title: "Industry Project",
                    topics: [
                        "Project: Flange Automation Tool",
                        "Identifying Various Holes Automatically"
                    ]
                },
                {
                    number: 5,
                    title: "SolidWorks Master Model Automation",
                    topics: [
                        "Creating & Controlling Parametric Parts",
                        "Managing Part Parameters",
                        "Rebuilding & Refitting Models",
                        "Industry Project: Create & Update Flange Parameters"
                    ]
                },
                {
                    number: 6,
                    title: "Document Properties Handling",
                    topics: [
                        "Read & Write Standard File Properties",
                        "Create, Read & Write Custom Properties"
                    ]
                },
                {
                    number: 7,
                    title: "Drawing Views",
                    topics: [
                        "Creating Drawing Views",
                        "Industry Project: Create Standard Views of a Model"
                    ]
                },
                {
                    number: 8,
                    title: "Dimensions in Drawings",
                    topics: [
                        "Learn to Access & Control Drawing Dimensions"
                    ]
                },
                {
                    number: 9,
                    title: "SolidWorks Assemblies",
                    topics: [
                        "Traverse Components in an Assembly",
                        "Industry Project: Identify All Mates in an Assembly"
                    ]
                },
                {
                    number: 10,
                    title: "Product Configurator Development",
                    topics: [
                        "Industry Project: SolidWorks Product Configurator",
                        "Automatically Generate Custom Assemblies",
                        "Create & Manage Bills of Materials (BoM)",
                        "Set Up a Custom Parts Library",
                        "Build a User Interface for Part Selection"
                    ]
                }
            ]
        }
    ],

    videos: [
        {
            category: "CAD Customization & Automation",
            title: "CAD Customization And Automation Session",
            videoUrl:
                "https://www.youtube.com/embed/VpcpMwvQJy4?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=1&forigin=https%3A%2F%2Ffeesworth.com%2Fsolidworks-api-customization-automation-training%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fcreo-toolkit-customization-training%2F&vf=1"
        },
        {
            category: "SOLIDWORKS API Sample Project -Tank Design Automation",
            title: "Solidworks Automation with C#  NET API Demo Project",
            videoUrl:
                "https://www.youtube.com/embed/ERzUOA5Yo-g?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=3&forigin=https%3A%2F%2Ffeesworth.com%2Fsolidworks-api-customization-automation-training%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fcreo-toolkit-customization-training%2F&vf=1"
        },
        {
            category: "NX Open API Sample Project",
            title: "NX Customization Training. NX Open API Training, CAD Customization Training. Sample Students Project",
            videoUrl:
                "https://www.youtube.com/embed/XXTr_xjRZto?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=5&forigin=https%3A%2F%2Ffeesworth.com%2Fsolidworks-api-customization-automation-training%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fcreo-toolkit-customization-training%2F&vf=1"
        },
        {
            category: "Real First Day Class - For students new to Programming.",
            title: "Day 1: Programming Class C#.NET",
            videoUrl:
                "https://www.youtube.com/embed/7U2z7LUMH9g?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=7&forigin=https%3A%2F%2Ffeesworth.com%2Fsolidworks-api-customization-automation-training%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fcreo-toolkit-customization-training%2F&vf=1"
        }
    ],

    faq: [
        {
            question: "What is SOLIDWORKS API?",
            answer:
                "SolidWorks API (Application Programming Interface) is a set of tools and functions that allow users to automate and customize SolidWorks software, a widely used computer-aided design (CAD) program. With the SolidWorks API, you can create custom applications, scripts, and plugins to enhance design processes, automate repetitive tasks, and integrate SolidWorks with other software, streamlining your CAD workflow."
        },
        {
            question: "How Much Salary?",
            answer: [
                "Solidworks Developers often receive significantly higher salaries compared to Solidworks designers. This is because they can customize solidworks and create automation tools that can perform tasks that would be challenging for many individuals to accomplish without such tools.",

                "For a detailed explanation, please view the video located at this page."
            ]
        },
        {
            question: "I have SolidWorks design experience",
            answer: [
                "Having SolidWorks design experience is an advantage. It allows you to fully leverage your design skills and familiarity with SolidWorks tools.",

                "You can adeptly assess and make informed decisions about which aspects to automate and the value that automation brings."
            ]
        },
        {
            question: "Job Guaranteed?",
            answer: [
                "Generally No.",
                "Sometimes Yes.",
                "Please speak to the coordinator for more details."
            ]
        },
        {
            question: "Which programming language?",
            answer:
                "C#.NET is preferred for Solidworks customization & Solidworks Automation."
        },
        {
            question: "Job opportunities?",
            answer:
                "This skill is quite rare, with a limited number of professionals available in the market compared to the growing demand. Consequently, the job opportunities in this field are in high demand and offer promising prospects."
        }
    ]
};

export default solidworksApiCourse;